import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM, ScreenView } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Modal, Space, Switch, Button } from 'antd';
import columnIcon from '../../assets/images/icons/column.svg'
import { Link } from 'react-router-dom'
import FullLoader from "../../assets/images/full-page-loader.gif"
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import { jwtDecode } from "jwt-decode";
import noData from '../../assets/images/data-graph/no-data.svg';
import TableLoader from "../TableLoader";
import errorData from '../../assets/images/data-graph/error-data.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import imIcon from '../../assets/images/icons/skype.svg';
import teamsIcon from '../../assets/images/icons/teams_icon_v2.svg';
import telegramIcon from '../../assets/images/icons/telegram.svg';
import wechatIcon from '../../assets/images/icons/wechat.svg';
import { notifysuccess } from "../../utils/toast";
import { notifyfailure } from "../../utils/toast";
import { notifycatch } from "../../utils/toast";
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";
import AddUserIcon from '../../assets/newlayout/add_user_icon.svg';
import HoverCloseIcon from '../../assets/images/icons/hover_close.svg';
import constantData from "../../constants/constantData.json";
import deleteIcon from '../../assets/images/icons/trash.svg';
import SureIcon from '../../assets/newlayout/sure_icon.svg';

const { Option } = Select;

const AdminUserList = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    const [colvis, setColvis] = useState({
        "z_cate": true,
        "invent_type": true,
        "p_name": true,
        "createdAt": true
    })

    const columnsAll = [
        {
            title: 'Action',
            dataIndex: 'action',
            // render: (data) => <div className='badge_content--approved'>{data}</div>,
            // fixed: 'left',
            width: 60,
            // onHeaderCell: () => ({
            //     className: 'border_right_0',
            // }),

            render: (text, record) => {
                return (
                    <div className='btn_group'>
                        {record.Role === "u_admin" ?
                            <Tooltip title="Delete User">
                                <button className='download_icon download_icon_d2'
                                    onClick={() => { setDeletePendingRecord(record); setDeleteModalOpen(true); }}>
                                    <img src={deleteIcon} alt='USP' /></button>
                            </Tooltip>
                            :
                            <button className='download_icon download_icon_d2'
                                style={{ pointerEvents: "none", opacity: "0.2" }}>
                                <img src={deleteIcon} alt='USP' /></button>
                        }
                    </div >
                )
            },
        },
        {
            title: "Name",
            dataIndex: "Name",
            key: "Name",
            width: 200,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Role",
            dataIndex: "Role",
            width: 200,
            key: "Role",
            // hidden: !colvis["z_cate"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text, record) => {
                return (
                    <>
                        {record.Role === "u_admin" ?
                            <>
                                <div className="usertable_badges_d2" style={{ display: "flex", justifyContent: "flex-start", gap: "0.5rem" }}>
                                    <div className={`table_badges--d2 --user_cls`}>
                                        User
                                    </div>
                                    {record["PID"] !== undefined &&
                                        <div className={`table_badges--d2 --numb_cls`}>
                                            {record["PID"]}- {record["PNAME"]}

                                        </div>
                                    }
                                </div>
                            </>
                            :
                            <div className="usertable_badges_d2">
                                <div className={`table_badges--d2 --${text === "mobops" ? "blue" : text === "sa" ? "green" : "pink"}`}>
                                    {text === "mobops" ? "Mobile Ops" : text === "sa" ? "Super Admin" : text === "am" ? "AM" : text}
                                </div>
                            </div>
                        }
                    </>
                )
            }
        },
        {
            title: "Organization Name",
            dataIndex: "Organization Name",
            width: 200,
            key: "Organization Name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
        },
        {
            title: "Email",
            dataIndex: "Email",
            width: 200,
            key: "Email",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Website",
            dataIndex: "Website",
            width: 200,
            key: "Website",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data) =>
                <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>
            ,
        },
        {
            title: "IM",
            dataIndex: "IM",
            width: 200,
            key: "IM.value",
            sortDirections: ['ascend', 'descend', 'ascend'],
            // hidden: !colvis["IM"],
            render: (text) => <div className='im_type text_dark'>
                {text?.label === "telegram" ?
                    <img src={telegramIcon} alt='USP' /> :
                    text?.label === "wechat" ?
                        <img src={wechatIcon} alt='USP' /> :
                        <img src={teamsIcon} alt='USP' />
                }
                {text?.value}</div>
        }
    ];

    const columnsPublisher = [

        {
            title: 'Action',
            dataIndex: 'action',
            width: 60,
            render: (text, record) => (
                <div className='btn_group'>
                    <Tooltip title="Delete User">
                        <button className='download_icon download_icon_d2'
                            onClick={() => { setDeletePendingRecord(record); setDeleteModalOpen(true); }}>
                            <img src={deleteIcon} alt='USP' />
                        </button>
                    </Tooltip>
                </div>
            ),
        },
        {
            title: "Name",
            dataIndex: "Name",
            key: "Name",
            width: 300,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        // {
        //     title: "Role",
        //     dataIndex: "Role",
        //     width: 200,
        //     key: "Role",
        //     // hidden: !colvis["z_cate"],
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        //     render: (text) => {
        //         return (
        //             <>
        //                 <div className="usertable_badges_d2">
        //                     <div className={`table_badges--d2 --${text === "mobops" ? "blue" : text === "sa" ? "green" : "pink"}`}>
        //                         {text === "mobops" ? "Mobile Ops" : text === "sa" ? "Super Admin" : text === "am" ? "AM" : text}
        //                     </div>
        //                 </div>
        //             </>
        //         )
        //     }
        // },
        // {
        //     title: "Organization Name",
        //     dataIndex: "Organization Name",
        //     width: 300,
        //     key: "Organization Name",
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        // },
        {
            title: "Email",
            dataIndex: "Email",
            width: 300,
            key: "Email",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        // {
        //     title: "Website",
        //     dataIndex: "Website",
        //     width: 200,
        //     key: "Website",
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        //     render: (data) => <Link style={{ textDecoration: "none", cursor: "default" }} className='text_primary' >{data}</Link>,
        // },
        {
            title: "IM",
            dataIndex: "IM",
            width: 250,
            key: "IM.value",
            sortDirections: ['ascend', 'descend', 'ascend'],
            // hidden: !colvis["IM"],
            render: (text) => <div className='im_type text_dark'>
                {text?.label === "telegram" ?
                    <img src={telegramIcon} alt='USP' /> :
                    text?.label === "wechat" ?
                        <img src={wechatIcon} alt='USP' /> :
                        <img src={teamsIcon} alt='USP' />
                }
                {text?.value}</div>
        },
        {
            title: "Created At",
            dataIndex: "CreatedAt",
            width: 250,
            key: "CreatedAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
    ];

    const columnsUAdmin = [
        {
            title: "Name",
            dataIndex: "Name",
            key: "Name",
            width: 300,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },

        {
            title: "Email",
            dataIndex: "Email",
            width: 300,
            key: "Email",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "IM",
            dataIndex: "IM",
            width: 300,
            key: "IM.value",
            sortDirections: ['ascend', 'descend', 'ascend'],
            // hidden: !colvis["IM"],
            render: (text) => <div className='im_type text_dark'>
                {text?.label === "telegram" ?
                    <img src={telegramIcon} alt='USP' /> :
                    text?.label === "wechat" ?
                        <img src={wechatIcon} alt='USP' /> :
                        <img src={teamsIcon} alt='USP' />
                }
                {text?.value}</div>
        },
        {
            title: "Created At",
            dataIndex: "CreatedAt",
            width: 300,
            key: "CreatedAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });



    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const [filterShow, setFilterShow] = useState(false)
    const [filterApply, setFilterApply] = useState({ role: [] })
    const [filterApplyApiCall, setFilterApplyApiCall] = useState({ role: [] })
    const dropdownRef = useRef(null)
    const filterShowRef = useRef(filterShow)




    function handleFilterApply(type, value) {
        let tempFilterApply = { ...filterApply }
        if (type === "role") {
            const index = filterApply.role.indexOf(value)
            if (index === -1) {
                tempFilterApply.role.push(value)
            } else {
                tempFilterApply.role.splice(index, 1)
            }
        }
        setFilterApply(tempFilterApply)
    }

    useEffect(() => {
        filterShowRef.current = filterShow
    }, [filterShow])

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && filterShowRef) {
                let temp = JSON.parse(JSON.stringify(filterApplyApiCall))
                setFilterApply({ role: temp.role })
                setFilterShow(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => { document.removeEventListener("mousedown", handleClickOutside) }
    })

    useEffect(() => {
        if (!initialLoad) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage)
            setApicall(!apiCall)
        }
    }, [filterApplyApiCall])

    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + (jwtDecode(token).role === "admin" || jwtDecode(token).role === "u_admin" || jwtDecode(token).role === "am" ? "user/usersAdminList" : "user/usersList") + `?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}&role=${filterApplyApiCall.role.join(',')}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }


                    // setTimeout(() => {
                    setLoading(false)
                    // }, 300)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        // BlockAM()
        // BlockAdmin()
        // BlockAM()
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        // let checkRole = jwtDecode(token).role;
        // setCheckRole(checkRole)
        // }
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = tempPage.current - 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };


    ///--------------------------delete confirmation modal ----------------------------
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deletePendingRecord, setDeletePendingRecord] = useState(null);

    const handleDeleteConfirm = () => {
        let token = Cookies.get("token_xapads_ssp");
        if (!token) return;
        axios
            .post(configData.SERVER_URL + `user/deleteusers`, { userId: deletePendingRecord?._id },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                }
            )
            .then((response) => {
                notifysuccess(response.data.message);
                setApicall(!apiCall);
            })
            .catch((error) => {
                if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                    }
                } else {
                    notifycatch();
                }
            })
            .finally(() => {
                setDeleteModalOpen(false);
                setDeletePendingRecord(null);
            });
    };

    ///--------------------------user create modal related code ----------------------------
    const [checkRole, setCheckRole] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setEmailRegister("")
        setEmailRegisterIsRequiredError(false)
        setEmailRegisterUrlError(false)
        setIm("")
        setImIsRequiredError(false)
        setSelectedIm("telegram")
        setName("")
        setNameIsRequiredError(false)
        setButtonValue(false)
        setSelectedPublisher("")
        setPublisherError(false)

        if (checkRole !== "admin" && checkRole !== "u_admin") {
            setOrganizationName("")
            setCompanyWebiste("")
        }

    };

    const [publisherList, setPublisherList] = useState([]);
    const [selectedPublisher, setSelectedPublisher] = useState("");
    const [publisherError, setPublisherError] = useState(false);

    const [organizationName, setOrganizationName] = useState("");
    const [companyWebsite, setCompanyWebiste] = useState("");

    const [emailRegister, setEmailRegister] = useState("");
    const [emailRegisterIsRequiredError, setEmailRegisterIsRequiredError] = useState(false);
    const [emailRegisterUrlError, setEmailRegisterUrlError] = useState(false);

    const [im, setIm] = useState("");
    const [imIsRequiredError, setImIsRequiredError] = useState(false);

    const [selectedIm, setSelectedIm] = useState("telegram");

    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const [buttonValue, setButtonValue] = useState(false);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };


    useEffect(() => {
        const token = Cookies.get("token_xapads_ssp");
        if (!token) return;
        setCheckRole(jwtDecode(token).role)
        if ((jwtDecode(token).role === "admin" || jwtDecode(token).role === "u_admin")) return;

        axios
            .get(configData.SERVER_URL + "zone/pubMinifiedList", {
                headers: { "Content-Type": "application/json", "x-access-token": token },
            })
            .then((res) => setPublisherList(res.data.data || []))
            .catch(() => { });
    }, []);

    useEffect(() => {
        const token = Cookies.get("token_xapads_ssp");
        if (!token) return;

        if ((jwtDecode(token).role === "admin" || jwtDecode(token).role === "u_admin")) {
            axios
                .get(configData.SERVER_URL + "ops/org_name", {
                    headers: { "Content-Type": "application/json", "x-access-token": token },
                })
                .then((res) => {
                    setOrganizationName(res.data.data.orgName || "")
                    setCompanyWebiste(res.data.data.compWebsite || "")
                }
                )
                .catch(() => { });
        }
    }, []);

    const handlePublisherChange = (value) => {
        setSelectedPublisher(value);
        setOrganizationName(publisherList.find(item => item.value === value)?.o_name);
        setCompanyWebiste(publisherList.find(item => item.value === value)?.compWebsite)
        setPublisherError(false);
    };

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }


    function onChangeEmailRegister(event) {
        setEmailRegisterIsRequiredError(false);
        setEmailRegister(event.target.value);

        if (validateEmail(event.target.value) === null) {
            setEmailRegisterUrlError(true);
        } else {
            setEmailRegisterUrlError(false);
        }
    }

    function onBlurEmailRegister(event) {
        if (event.target.value.trim().length === 0) {
            setEmailRegisterUrlError(false);
            setEmailRegisterIsRequiredError(true);
        }
        else {
            if (validateEmail(event.target.value.trim()) === null) {
                setEmailRegisterUrlError(true);
            } else {
                setEmailRegisterUrlError(false);
            }
        }
        setEmailRegister(event.target.value.trim());
    }


    function onChangeIm(event) {
        setImIsRequiredError(false);
        setIm(event.target.value);
    }

    function onBlurIm(event) {
        if (event.target.value.trim().length === 0) {
            setImIsRequiredError(true);
        }
        setIm(event.target.value.trim())
    }

    function onChangeSelectedIm(event) {
        setSelectedIm(event);
    }

    const handleSubmitModal = async (e) => {
        e.preventDefault();
        if (
            name !== "" &&
            emailRegister !== "" &&
            im !== "" &&
            ((checkRole !== "admin" && checkRole !== "u_admin") ? selectedPublisher !== "" : true)
        ) {
            if (
                nameIsRequiredError === false &&
                emailRegisterIsRequiredError === false &&
                emailRegisterUrlError === false &&
                imIsRequiredError === false &&
                ((checkRole !== "admin" && checkRole !== "u_admin") ? publisherError === false : true)
            ) {
                let payload = {
                    p_name_user: name,
                    email_user: emailRegister,
                    im_user: { "label": selectedIm, "value": im },
                    o_name_user: organizationName,
                    c_website_user: companyWebsite

                };

                if ((checkRole !== "admin" && checkRole !== "u_admin")) {
                    payload.publisherId = selectedPublisher
                }

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                    let token = Cookies.get("token_xapads_ssp");

                    setButtonValue(true);

                    axios
                        .post(configData.SERVER_URL + "user/createNewUser", payload,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": token,
                                },
                            }
                        )
                        .then((response) => {

                            notifysuccess(response.data.message);
                            setApicall(!apiCall)
                            handleCancel()

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error?.response?.data?.message?.length !== 0) {
                                    notifyfailure(error.response.data.message)
                                }
                            } else {
                                notifycatch()
                            }
                            setButtonValue(false);
                        });

                }
            }
        } else {
            if (name === "") {
                setNameIsRequiredError(true);
            }
            if (emailRegister === "") {
                setEmailRegisterIsRequiredError(true);
            }
            if (im === "") {
                setImIsRequiredError(true);
            }
            if (selectedPublisher === "" && (checkRole !== "admin" && checkRole !== "u_admin")) {
                setPublisherError(true);
            }
        }
    };


    return (
        <>


            <div className="container_box--wrapper pt_header"
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        User List
                    </h1>
                </div>

                <div
                    className={`
  table_and_filter_div 
  --without_filter_div
  ${data.length === 0 ? "--no_data_div_height" : ""}`}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="form_content_block--group">
                                    {!initialLoad &&
                                        <Input
                                            type='text'
                                            className='form_control basic md search_input w_table_search'
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {

                                                if (e.target.value.trim().length === 0) {
                                                    setLoading(true)
                                                }

                                                setSearch(e.target.value)
                                            }}
                                        />
                                    }
                                </div>



                                <div className="custom_filter_design_d2 justify-content-end --new_layout_design_btn">
                                    {checkRole !== "admin" && checkRole !== "u_admin" && checkRole !== "am" &&
                                        <Dropdown ref={dropdownRef} show={filterShow}
                                            onToggle={() => { setFilterShow(!filterShow) }}
                                            className="" autoClose={false}>
                                            <div className="position-relative hover_effec_hide_show_d2">
                                                <Dropdown.Toggle id="dropdown-autoclose-false-userlist">
                                                    <Button icon={
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    }>
                                                        Filter
                                                        {filterApplyApiCall.role.length > 0 &&
                                                            <div className="selected_filter_tag_d2">
                                                                <div>{filterApplyApiCall.role.length}</div>
                                                            </div>
                                                        }
                                                    </Button>
                                                </Dropdown.Toggle>
                                                {filterApplyApiCall.role.length > 0 &&
                                                    <div className="clear_filter_icon_d2" style={{ right: '1.7rem', top: '0.8rem' }}>
                                                        <button type="button">
                                                            <img src={HoverCloseIcon} alt="" onClick={() => {
                                                                setFilterApply({ role: [] })
                                                                setFilterApplyApiCall({ role: [] })
                                                                setFilterShow(false)
                                                            }} />
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                            <Dropdown.Menu>
                                                <div className="filter_inner_heading_d2">
                                                    <p className="m-0">Role</p>
                                                    <div className="checkbox_value_select_d2">
                                                        {
                                                            [
                                                                { value: "am", label: "AM" },
                                                                { value: "mobops", label: "Mobile Ops" },
                                                                { value: "sa", label: "Super Admin" },
                                                                { value: "u_admin", label: "User" }

                                                            ].map(role => (
                                                                <div className="checkbox_active_design_d2" key={role.value}>
                                                                    <input type="checkbox" name={`role_${role.value}`} id={`role_${role.value}`}
                                                                        checked={filterApply.role.includes(role.value)}
                                                                        onChange={() => { handleFilterApply("role", role.value) }}
                                                                    />
                                                                    <label htmlFor={`role_${role.value}`} className="single_checkbox_select_d2">
                                                                        {role.label}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                    </div>
                                                    <hr />
                                                </div>
                                                <div className="filter_bottom_btns_d2 text-end">
                                                    <button className="reset" type="button" onClick={() => {
                                                        setFilterApply({ role: [] })
                                                        setFilterApplyApiCall({ role: [] })
                                                        setFilterShow(false)
                                                    }}>Reset</button>
                                                    <button className="apply" type="button"
                                                        onClick={() => {
                                                            let tempdata = JSON.parse(JSON.stringify(filterApply))
                                                            setFilterApplyApiCall(tempdata)
                                                            setFilterShow(false)
                                                        }}
                                                        disabled={JSON.stringify(filterApplyApiCall) === JSON.stringify(filterApply)}
                                                    >Apply</button>
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    }


                                    <button className='btn btn_primary w_fit_content md' onClick={showModal}>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 3.33334V12.6667" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M3.33325 8H12.6666" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Add New User
                                        </span>
                                    </button>
                                </div>




                            </div>
                        </div>
                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <>
                                    {(checkRole === "admin" || checkRole === "am") ?


                                        <Table
                                            columns={columnsPublisher}
                                            pageSize={100}
                                            dataSource={data}
                                            onChange={handleTableChange}
                                            pagination={false}
                                            rowKey={(record) => record.id}
                                            locale={locale}
                                            scroll={{ x: 1500, y: 'calc(100vh - 30.9rem' }} />
                                        :
                                        (checkRole === "u_admin") ?


                                            <Table
                                                columns={columnsUAdmin}
                                                pageSize={100}
                                                dataSource={data}
                                                onChange={handleTableChange}
                                                pagination={false}
                                                rowKey={(record) => record.id}
                                                locale={locale}
                                                scroll={{ x: 1500, y: 'calc(100vh - 30.9rem' }} />
                                            :
                                            <Table
                                                columns={columnsAll}
                                                pageSize={100}
                                                dataSource={data}
                                                onChange={handleTableChange}
                                                pagination={false}
                                                rowKey={(record) => record.id}
                                                locale={locale}
                                                scroll={{ x: 1500, y: 'calc(100vh - 30.9rem' }} />
                                    }
                                </>



                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col >
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row >
                            }
                        </div >
                    </div >
                </div >
            </div >


            <Modal
                className='custom_modal custom_modal_form_d2'
                title={
                    <div className='custom_modal--header'><h3 className='heading'>
                        <img src={AddUserIcon} alt='USP' /> Add New User</h3>
                    </div>
                }
                width={780}
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onCancel={handleCancel}
                maskClosable={false}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end publisher_domain_upload_footer gap_8">
                        <div className="d_flex justify_content_start align_items_center">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                onClick={handleCancel}
                                disabled={buttonValue}
                            >Discard</button>
                        </div>

                        <div className="btn_group justify-content-end gap_8">
                            {buttonValue ?
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content loader"

                                >
                                    <span>Create Zone</span>

                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                                :
                                <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmitModal}>Create User</button>
                            }
                        </div>
                    </div>
                ]}>
                <div className="custom_tabs_wrapper">


                    {/* Tabs content */}
                    <div className="custom_tab_content --custom_tab_content_form-div">
                        <div>
                            <div className="custom_modal--body">
                                <div className="tab_content--body">
                                    {(checkRole !== "admin" && checkRole !== "u_admin") &&
                                        <div className="form_content_block--group modal_form_bottom_gap_d2">
                                            <label className="form_label">Publisher *</label>
                                            <Select
                                                showSearch={true}
                                                className={`form_select basic basic_two no_search ${publisherError ? ' error_border' : ''}`}
                                                placeholder="Select publisher"
                                                optionFilterProp="label"
                                                value={selectedPublisher || undefined}
                                                // open={true}
                                                onChange={handlePublisherChange}
                                                options={publisherList}
                                            // disabled={zoneType === "publica" && uploadedFile}
                                            />
                                            <span className="error_content">
                                                {publisherError ? "Publisher is required" : " "}
                                            </span>
                                        </div>
                                    }
                                    <div className="form_content_block--group modal_form_bottom_gap_d2">
                                        <Row gutter={20}>
                                            <Col span={12}>
                                                <label className="form_label">Publisher Name *</label>
                                                <Input

                                                    className="form_control basic"
                                                    // className={
                                                    //     nameIsRequiredError
                                                    //         ? "form_control basic error"
                                                    //         : "form_control basic"
                                                    // }
                                                    placeholder="Publisher Name"
                                                    autocomplete="off"
                                                    value={name}
                                                    onBlur={onBlurName}
                                                    onChange={onChangeName}
                                                />
                                                {nameIsRequiredError && (
                                                    <span className="error_content h_error">

                                                        <> This field is required</>
                                                    </span>
                                                )}

                                            </Col>
                                            <Col span={12}>
                                                <label className="form_label">Organization Name *</label>
                                                <Input
                                                    className="form_control basic"
                                                    // className={
                                                    //     nameIsRequiredError
                                                    //         ? "form_control basic error"
                                                    //         : "form_control basic"
                                                    // }
                                                    value={organizationName}
                                                    disabled
                                                    placeholder="Organization Name"
                                                    autocomplete="off"
                                                // value={name}
                                                // onBlur={onBlurName}
                                                // onChange={onChangeName}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="form_content_block--group modal_form_bottom_gap_d2 mb-0">
                                        <Row gutter={20}>
                                            <Col span={12}>
                                                <label className="form_label">Email ID *</label>
                                                <Input
                                                    // className={
                                                    //     (emailRegisterIsRequiredError || emailRegisterUrlError)
                                                    //         ? "form_control basic error"
                                                    //         : "form_control basic"
                                                    // }
                                                    className="form_control basic"
                                                    placeholder="Enter Email ID"
                                                    autocomplete="off"
                                                    value={emailRegister}
                                                    onBlur={onBlurEmailRegister}
                                                    onChange={onChangeEmailRegister}
                                                />
                                                {emailRegisterIsRequiredError && (
                                                    <span className="error_content h_error">
                                                        <> This field is required</>
                                                    </span>
                                                )}

                                                {emailRegisterUrlError && (
                                                    <span className="error_content h_error">
                                                        <> Invalid Email Address</>
                                                    </span>
                                                )}
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group">
                                                    <label className="form_label">IM * </label>
                                                    <Space.Compact className='form_compact'>
                                                        <Select
                                                            popupMatchSelectWidth={true}
                                                            className='form_select'
                                                            value={selectedIm}
                                                            onChange={onChangeSelectedIm}
                                                            options={constantData.IM_OPTIONS}

                                                        />
                                                        <Input
                                                            className="form_control basic"
                                                            value={im}
                                                            placeholder="Username"
                                                            onChange={onChangeIm}
                                                            onBlur={onBlurIm}
                                                            autocomplete="off"
                                                        />
                                                    </Space.Compact>
                                                    {imIsRequiredError && (
                                                        <span className="error_content h_error">
                                                            <> This field is required</>
                                                        </span>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                title={
                    <div className='custom_modal--header'>
                        <div className="d_flex justify_content_between">
                            <h3 className='heading'>
                                <img src={SureIcon} alt='USP' /> Are you sure?
                            </h3>
                        </div>
                    </div>
                }
                centered
                footer={false}
                maskClosable={false}
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={deleteModalOpen}
                width={500}
                className='custom_modal custom_modal_form_d2'
                onCancel={() => { setDeleteModalOpen(false); setDeletePendingRecord(null); }}
            >
                <div className="custom_modal--body p-0">
                    <div className="tab_content--body border-0" style={{ padding: '2.4rem' }}>
                        <div className="container_box--form-container p-0 border-0 mb-0">
                            <Row gutter={16}>
                                <Col span={24}>
                                    <p className="modal_text_para">
                                        Are you sure you want to <span className="text" style={{ color: '#B42318' }}>"Delete"</span> this user?
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className='two_modal_btn'>
                        <div className="btn_group justify-content-end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                onClick={() => { setDeleteModalOpen(false); setDeletePendingRecord(null); }}
                            >Cancel</button>
                            <button className="w_120_d2 btn btn_primary w_fit_content"
                                onClick={handleDeleteConfirm}
                            >Yes, Delete</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AdminUserList;
